const DEFAULT_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"; // eslint-disable-line max-len
const MONO_FONT_FAMILY = "SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace";

export {
  DEFAULT_FONT_FAMILY,
  MONO_FONT_FAMILY,
};



// WEBPACK FOOTER //
// ./src/Constants/fonts.js